import { useStorage } from './useStorageFallback';

export function useLocalStorage(key, defaultValue, opts) {
  return useStorage('local', key, defaultValue, opts);
}
